import { j as e } from "../../jsx-runtime-82a9ddf6.js";
import { Typography as f } from "../typography/index.js";
import { cn as r } from "../../lib/cn.js";
import { forwardRef as h } from "react";
const x = h(({
  label: o,
  checked: s,
  onChange: t,
  className: a,
  wrapperStyle: d,
  disabled: c
}, p) => {
  const l = (i) => {
    t(i.target.checked);
  }, n = r("flex flex-row items-center gap-3", d), b = r(
    "form-checkbox",
    "w-[18px] h-[18px]",
    "border rounded",
    "focus:ring-0 focus:ring-transparent focus:ring-offset-0 focus:ring-offset-transparent",
    "bg-white",
    "border-slate-200",
    "hover:border-purple-600 dark:hover:border-purple-400",
    "focus:border-purple-600 dark:focus:border-purple-400",
    "text-purple-600",
    "disabled:bg-slate-50",
    "disabled:border-slate-200 disabled:hover:border-slate-200",
    "dark:disabled:hover:border-slate-200",
    a
  );
  return /* @__PURE__ */ e.jsxs("div", { className: n, children: [
    /* @__PURE__ */ e.jsx(
      "input",
      {
        className: b,
        type: "checkbox",
        checked: s,
        disabled: c,
        onChange: l,
        ref: p
      }
    ),
    /* @__PURE__ */ e.jsx(f, { children: o })
  ] });
});
x.displayName = "Checkbox";
export {
  x as Checkbox
};
